import Fuse from 'fuse.js'

// composant vide pour afficher par défaut
const FilterEmpty = {
	props: {
		param: Object,	// {title, k, rows : [k, v, cache, inSearch]} }		
	},
	template: `
	<div></div>
 `
}


// composant checkbox
const FilterCheckbox = {
	props: {
		param: Object,
		/*{
			titre,								// Titre 
			liste : [k, v]}, 	// Tableau des valeurs possibles
		 	valeur : { checked:[] }				// valeur retournée
			estInitialise : false				// permet de détecter que les paramètres sont nouveaux et d'initialiser le composant
		} */
	},
	data() {
		// Cherche les valeurs qui ne sont pas dans les valeurs possibles
		const ks = this.param.liste.map(u=>u.k);
		const nouveau = this.param.valeur.checked.filter( u=> ks.indexOf(u)<0 ).map(u=>({k:u, v:u}));
		
		
		return {
			searchFiltre: "",
			fuseFiltre: null,
			valeursPossibles: nouveau.concat(this.param.liste)
		}
	},
	beforeUpdate: function () {
		/* console.log("FilterCheckbox beforeUpdate") */
		const ks = this.param.liste.map(u=>u.k);
		const nouveau = this.param.valeur.checked.filter( u=> ks.indexOf(u)<0 ).map(u=>({k:u, v:u}));

		if (!this.param.estInitialise) {
			/* console.log("initialise composant"); */
			this.param.estInitialise = true;
			this.fuseFiltre = null;
			this.searchFiltre = "";
			this.valeursPossibles =  nouveau.concat(this.param.liste);
		}
	},
	watch: {
		"searchFiltre"(val) {
			if (!this.fuseFiltre ) {
				const optionsFiltres = { includeScore: false, minMatchCharLength: 2, threshold: 0.2, keys: ['v'] };
				this.fuseFiltre = new Fuse(this.valeursPossibles, optionsFiltres);				
			}			
			let searchResult = this.fuseFiltre.search(val);			
			//
			let keys = searchResult.map(u => u.item.k);
			for (const u of this.valeursPossibles) u.inSearch = (keys.indexOf(u.k) > -1);
		},
	},
	
	//; height:auto ??? pour activer le scroll vertical ? 
	template: `
	<div>
		<h4 class="">{{param.titre}}</h4>
		<div class="card bg-light border" style="min-height:100%">

		<div class="card-header mt-3">
			<input type="search" class="form-control form-control-rounded list-search" v-model="searchFiltre"  placeholder="Search">
		</div>
		<div class="card-body card-adjust py-0  overflow-auto" style="display: block;  overflow-y: scroll; min-height: 12rem">
		
			<div class="col">
				<div class=" ">
					<ul class=" list-group list-group-flush list mt-2">
					<template v-for="filter, i in valeursPossibles">
						<li v-if="!filter.cache" class="list-group-item p-1 m-1 ps-2"
						:class='(filter.inSearch)? "text-primary bg-light bg-opacity-50 border border-primary border-opacity-10 rounded-2" : "" '>
						<input class="form-check-input" 
							type="checkbox"
							:nameSearch='filter.v'
							:value="filter.k"
							:id="filter.k"
							v-model="param.valeur.checked">
						<label class="form-check-label ps-2" :for="filter.k"> {{filter.v.split('|').pop()||'none'}} </label>
						</li>
					</template>
					</ul>
				</div>
			</div>
		</div>
		</div>
  </div>
 `
}
/*
element.addEventListener('hidden.bs.dropdown', function (event) {
	//console.log("modal hide")
	if (onHide) onHide();
})*/

export { FilterCheckbox, FilterEmpty };

